"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const react_native_config_1 = __importDefault(require("react-native-config"));
const react_native_1 = require("react-native");
const package_json_1 = require("../../package.json");
const BACKEND_URL = react_native_1.Platform.OS === 'web' ? process.env.API_URL : react_native_config_1.default.API_URL;
axios_1.default.defaults.baseURL = BACKEND_URL;
axios_1.default.defaults.headers = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
};
axios_1.default.interceptors.request.use(config => {
    config.headers['X-App-Version'] = package_json_1.version;
    return config;
});
class TermsService {
    static async getActiveTerms() {
        return new Promise(resolve => {
            axios_1.default
                .get('/terms/active')
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
}
exports.default = TermsService;
